import { useCallback, useMemo } from 'react';
import NeoTooltip from "../design/design_components/neo/overlay/NeoTooltip.base";
import avatar from "../design/assets/img/wfi/avatar.svg";

export default function Avatar(props) {
  const calculeCoords = useCallback((coord_x, coord_y) => {
    const scaleFactorY = (props.img.clientHeight - props.img.spacingVertical) / props.img.naturalHeight;
    const scaleFactorX = (props.img.clientWidth - props.img.spacingHorizontal) / props.img.naturalWidth;
    return {
      coord_x: coord_x * scaleFactorX,
      coord_y: coord_y * scaleFactorY,
    }
  }, [props.img]);

  const { coord_x, coord_y } = useMemo(() => calculeCoords(props.coord_x, props.coord_y), [props.img, props.coord_x, props.coord_y]);

  return (<>
    <div
      id={`avatar-${props.id}`}
      style={{
      position: "absolute",
      zIndex: 3,
      top: `${coord_y.toFixed(2)}px`,
      left: `${coord_x.toFixed(2)}px`,
      transform: "translate(-50%, -70%)",
    }}>
      <img alt="avatar" src={avatar}/>
    </div>
    {props.tooltip &&
      <NeoTooltip target={`#avatar-${props.id}`} position="bottom">
        <p>{props.tooltip}</p>
      </NeoTooltip>
    }
  </>)
}